<template>
  <el-dialog v-loading="loading.dialog" class="task_model_dialog" top="5vh" center :title="newTitle" width="80%"
    :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="标题" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" :disabled="!isEditTask"></el-input>
      </el-form-item>
      <el-form-item label="PRD链接" v-if="form.prdLink" :label-width="formLabelWidth" prop="prdLink">
        <div @click="linkFn(form.prdLink)"
             style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.prdLink }}</div>
      </el-form-item>
      <el-form-item label="技术文档链接" v-if="form.techDocLink" :label-width="formLabelWidth" prop="techDocLink">
        <div @click="linkFn(form.techDocLink)"
             style="text-decoration: underline;color: #409EFF;cursor: pointer;display: inline-block;">
          {{ form.techDocLink }}</div>
      </el-form-item>
      <el-form-item label="技术描述" v-if="form.techDesc" prop="techDesc" :label-width="formLabelWidth">
        <el-input type="textarea" disabled="true" :rows="6" placeholder="请输入内容" v-model="form.techDesc" />
      </el-form-item>
      <el-form-item label="任务内容" prop="taskContent" :label-width="formLabelWidth">
        <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="form.taskContent" :disabled="!isEditTask">
        </el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="数据量级要求" prop="dataLevel" :label-width="formLabelWidth">
          <el-select filterable v-model="form.dataLevel" placeholder="请选择数据量级要求" :disabled="!isEditTask">
            <el-option v-for="(item, index) in allSelect.TEXTEDATALEVELREQUIREMENTS" :key="index" :label="item[0]"
              :value="item[0]"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="响应时间要求" prop="responseTime" :label-width="formLabelWidth">
          <el-select filterable v-model="form.responseTime" placeholder="请选择响应时间要求" :disabled="!isEditTask">
            <el-option v-for="(item, index) in allSelect.TEXTERESPONSETIMEREQUIREMENTS" :key="index" :label="item[0]"
              :value="item[0]" />
          </el-select>
        </el-form-item>
        <el-form-item label="并发量要求" prop="concurrency" :label-width="formLabelWidth">
          <el-select filterable v-model="form.concurrency" placeholder="请选择并发量要求" :disabled="!isEditTask">
            <el-option v-for="(item, index) in allSelect.TEXTECONCURRENCYREQUIREMENTS" :key="index" :label="item[0]"
              :value="item[0]" />
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="技术难度" prop="technicalDifficulty" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off" v-model="form.technicalDifficulty" placeholder="请选择技术难度" :disabled="!isEditTask">
            <el-option v-for="(item, index) in allSelect.TEXTERESPONSETECHNICALDIFFICULTY" :key="index" :label="item[0]"
                       :value="item[0]">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          <el-select filterable v-model="form.domain" :disabled="!isEditTask">
            <el-option v-for="(key, val) in allSelect.TEXTDOMAINS" :key="key" :label="key" :value="val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="涉及系统" prop="module" :label-width="formLabelWidth">
          <el-select filterable v-model="form.module" placeholder="请选择涉及系统" :disabled="!isEditTask">
            <el-option v-for="(value, key) in modules" :key="key" :label="value" :value="key" />
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="开发人员" prop="developerId" :label-width="formLabelWidth">
          <el-select autocomplete="off" size="mini" v-model="form.developerId" filterable placeholder="请选择开发人员" :disabled="!isEditTask">
            <el-option v-for="(key, value)  in allUserList.ALLUSERTYPE3" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="预估工时" prop="estimateWorkHour" :label-width="formLabelWidth">
          <el-input style="width: 92%;" type="number" v-model="form.estimateWorkHour" @change="handleEdit" placeholder="小时" :disabled="!isEditTask">时</el-input>
          <el-tooltip class="item" effect="light" placement="top">
            <div slot="content">
              <span>一天6工时，最多30工时</span>
            </div>
          <i class="el-icon-question" style="color: #409EFF;"></i>
          </el-tooltip>
        </el-form-item>
      <el-form-item v-if="isShowCompleteTime" label="计划完成日期" prop="planFinishDate" :label-width="formLabelWidth">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.planFinishDate" type="date" placeholder="请选择时间"
                          :picker-options="pickerOptions_plt"  :disabled="!isEditTask"/>
        </el-form-item>
      </div>
      <div style="display: flex;" v-if="!isCreate">
        <el-form-item label="状态" prop="p_issue_status" :label-width="formLabelWidth">
          <el-input :value="form.taskStatus" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="任务进度" :label-width="formLabelWidth">
          <el-input :value="(form.processRate || '0%')" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="BUG" :label-width="formLabelWidth">
          <el-input :value="form.bugHandlingcount + '/' + form.bugTotal" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
      </div>
      <div>
      <el-form-item :label-width="formLabelWidth" v-if="!isCreate && form.taskStatusCode == 1 && isDevloper">
        <div class="task-line"><label>工作区</label></div>
      </el-form-item>
        <el-form :model="pDevOpsForm" :rules="pDevOpsRules" ref="pDevOpsForm" >
        <div style="display: flex;">
        <el-form-item prop="branch" label="代码分支" :label-width="formLabelWidth" v-if="!isCreate  && !nonStandard">
            <el-select style="width:90%;" size="mini" @change="selectBranch" v-model="pDevOpsForm.branch"
                       filterable placeholder="请选择代码分支" :disabled="!isEditDevTask" @click.native="getBranchNew()">
              <el-option v-for="(key, value) in BRANCHS" :key="key" :label="key" :value="value">
              </el-option>
            </el-select>
        </el-form-item>
          <el-form-item prop="codeReviewerId" label="代码审核人" :label-width="formLabelWidth" v-if="!isCreate">
            <el-select style="width:90%;" size="mini" @change="selectCodeReviewer" v-model="pDevOpsForm.codeReviewerId"
                       multiple filterable  placeholder="请选择审核人" :disabled="!isEditDevTask" @click.native="getReviewUserList">
              <el-option v-for="(key, value)  in reviewList" :key="key" :label="key" :value="value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.taskStatusCode===2||form.taskStatusCode===3" label="联调时间:" prop="revisionHour" :label-width="formLabelWidth">
            <el-input  v-model="form.revisionHour"  :disabled="!(form.taskStatusCode === 2 && isDevloper && !isTaskCopy && step === 1)" @blur="handleInput"></el-input>
            <el-tooltip class="item" effect="light" placement="top">
              <div slot="content">
                <span>输入0到30带一位小数的数！</span>
              </div>
            <i class="el-icon-question" style="color: #409EFF;"></i>
          </el-tooltip>
          </el-form-item>
        </div>
          <div v-if="form.taskStatusCode > 1">
            <el-form-item label="提测附件" prop="adjunct" :label-width="formLabelWidth">
              <el-upload class="upload-demo" action="https://devops-test.ehsy.com/devops/common/upload"
                         :on-preview="handlePreview" :before-remove="beforeRemove" multiple :limit="5" :on-success="handleSuccess"
                         :on-remove="handleRemove" :before-upload="beforeUpload" :file-list="fileList" :disabled="isUploadFile">
                <el-button size="mini" type="primary" :disabled="isUploadFile">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-form-item v-if="!isCreate && historylist.length" label="任务历史" :label-width="formLabelWidth">
        <TaskHistory :list="historylist" />
      </el-form-item>
      <el-form :model="form" v-if="!isCreate && form.taskStatusCode > 1">
        <el-form-item class="comment_warp" label="评论" :model="form" :label-width="formLabelWidth">
          <Comment  :id="form.taskId" :busiId="form.taskId"  type="3"/>
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="step === 1 && form.taskId && isDemandReviewer && !isTaskCopy" type="primary" @click="changeStep">编 辑</el-button>
      <el-button :loading="loading.submitDev" type="primary" @click="developSubmit(1)" v-if="form.taskStatusCode === 1 && isDevloper && !isTaskCopy && step === 1">开 发</el-button>
      <el-button  type="primary" @click="onArrange()" v-if="form.taskStatusCode > 1 && isDevloper && !isTaskCopy && step === 1">部 署</el-button>
      <el-button :loading="loading.submitDev" type="warning" @click="submitTest()" v-if="form.taskStatusCode === 2 && isDevloper && !isTaskCopy && step === 1">提 测</el-button>
      <el-button v-show="(step === 1 && isCreate)  || (step === 2 && !isCreate)" :loading="loading.submit" type="warning" @click="onSubmit">{{ isCreate ? '创 建' : '提 交' }}</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" custom-class="task_model_dialog_child" width="85%" center
      :title="'【' + form.id + '】 ' + form.module + '.' + form.domain" :visible.sync="dialog.bugVisible" append-to-body>
      <TableBug :bugOption="bugOption" />
    </el-dialog>
    <Arrange v-if="dialogVisibleArrange" :dialogVisible='dialogVisibleArrange' :hideDialogVisible="handleArrangeClose" :formInfo="formArrangeInfo"></Arrange>
    <el-dialog center :append-to-body="true" title="延期原因" :visible.sync="dialogVisibleDelay" width="40%">
      <el-form :model="pSubmitForm" :rules="pSubmitRules" ref="pSubmitForm">
        <el-form-item label="延期类型" prop="reasonCode" :label-width="formLabelWidth" >
          <el-select v-model="pSubmitForm.reasonCode" placeholder="请选择" >
            <el-option v-for="(key, val) in typeList" :key="key" :label="key" :value="val" />
          </el-select>
        </el-form-item>
        <el-form-item label="原因" prop="reasonDetail" :label-width="formLabelWidth" >
          <el-input type="textarea" rows="3" v-model="pSubmitForm.reasonDetail" autocomplete="off" placeholder="延期原因" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary"   :loading="loading.submitDelay" @click="onSubmitDelay">确 定</el-button>
          <el-button size="small" @click="dialogVisibleDelay = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import Arrange  from "@/views/tops/devOps/producerSpace/components/arrange.vue";
import {
  getDevOpsSpaceTaskDetailApi,
  postDevopsSpaceTaskUpdateApi,
  postDevOpsSpaceDeleteTaskApi,
  getListMetersphereBugsApi,
  postDevOpsSpaceSubmitTaskApi,
  postODUDADcreateApi,
  postDevOpsSpaceCreateTaskApi,
  getDevOpsSpaceHistoryTaskListApi,
  postDevOpsSpaceUpdateBranchApi,
  getDevOpsSpaceReviewUserListApi,
  getDevOpsSpaceDelayReasonListApi,
  postDevOpsSpaceSUbmitDelayReasonApi,
  postDevOpsSpaceUpdateApi,
  postDevOpsSpaceUpdateGitApi, getDevOpsSpaceGitListApi
} from "@/server/tops/devOps";
import { TaskHistory } from '@/views/tops/devOps/components/list'
import { TableBug } from '@/views/tops/devOps/components/table'
import Share from "./share.vue"
import { mapState } from "vuex";
export default {
  components: { Editor, Comment, TaskHistory, Share, TableBug, Arrange },
  props: {
    isShowCompleteTime:{
      type: Boolean,
      default: true,
    },
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    back: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        revisionHour:0.0,
        taskHistory: [], // 任务历史
        domain: 'ehsy.com',
        describe:'',
        codeReviewerId: '',
        taskId:'',
        dataLevel:'无要求',
        responseTime:'无要求',
        concurrency:'无要求',
      },
      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        module: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        estimateWorkHour: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        technicalDifficulty: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate: {
          required: this.isShowCompleteTime?true:false,
          message: "必填",
          trigger: "blur",
        },
        domain: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        taskContent: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        dataLevel: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        responseTime: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        concurrency: {
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pDevOpsForm:{
        branch:'',
        codeReviewerId: '',
      },
      pDevOpsRules:{
        branch: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        codeReviewerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      pSubmitForm:{
        reasonCode:'',
        reasonDetail: '',
      },
      pSubmitRules:{
        reasonCode: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reasonDetail: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '140px',
      step: 1, // 1. 编辑 2. 提交
      loading: {
        dialog: false,
        submitDev: false,
        submit: false,
        submitTest: false,
        submitDelay: false,
      },
      bugOption: {
        count: 0,
        resolved: 0,
        new: 0,
        closed: 0,
        bugs: []
      },
      dialog: {
        bugVisible: false
      },
      username: '',
      link: {
        prdLink: false,
        techDocLink: false
      },
      showDetails: false,
      showLinkTo: false,
      showPLink: false,
      BRANCHS: {},
      dialogVisibleArrange: false,
      formArrangeInfo: {},
      historylist: [],
      userId:'',
      reviewList: [],
      dialogVisibleDelay: false,
      typeList: {},
      fileList: [],
      checkBranch: false,
    };
  },
  async created() {
    this.username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
   const username = this.username;
    const { reviewed_status = 'not_reviewed', taskInfo = {}, openType = '' ,reviewer, is_admin, techDocLink, techDesc, prdLink,user_pm } = this.formInfo;
    const { id = '' , taskId = '', task_progress = 0, status = '', pid = '', title = '', module = '',name = '' } = this.formInfo;
    this.form = { ...this.form, username: this.username, id, taskId, openType, pid, progress: task_progress, status, title, reviewed_status, reviewer, is_admin, techDocLink, techDesc, prdLink , module,name}
    this.showLinkTo = techDocLink;
    this.showReDetails = techDesc;
    this.showPLink = prdLink;
    if (taskId) await this.init();
    //if(taskId) await this.getBranchs();
    if(taskId) await this.getHistoryList();
    if(this.allUserList.ALLUSERIDLIST1[username]){
      this.userId = this.allUserList.ALLUSERIDLIST1[username];
    }
    this.checkBranch = false;

  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
        allSystem: (state) => state.devOps.ALLSYSTEM,
        allUserList: (state) => state.devOps.ALLUSERLIST,
      }
    ),
    // 是否显示编辑按钮
    showEdit() {
      if (this.isHistoryReviewed) return false;
      if (!this.form.taskId) return false;
      if (!this.isAdmin) return false;
      return true
    },
    modules() {
      let obj = {}
      const MODULESARR = this.allSelect.MODULESARR || [];
      MODULESARR.filter(itm => itm[2] === this.form.domain).forEach((item) => {
        obj[item[1]] = item[0];
      });
      return obj
    },
    // 判断是否是创建
    isCreate() {
      const { taskId = '', openType = '' } = this.formInfo;
      return !taskId || openType === 'copy';
    },
    isUpdate(){
      return this.form.taskId && this.form.openType !== 'copy';
    },

    //编辑任务
    isEditTask(){
      return (this.step === 2 && this.form.taskId && !this.isTaskCopy) || this.isCreate ;
    },
    //开发编辑提交开始测试
    isEditDevTask(){
      if(this.checkBranch) return true;
      return  this.form.taskId && (this.form.taskStatusCode === 1 || this.form.taskStatusCode === 2) && this.form.devloper.nameEn === this.username && !this.isTaskCopy ;
    },
    isTaskCopy(){
      return this.form.taskId && this.form.openType === 'copy';
    },
    //是否是技术评审人
    isDemandReviewer(){
      let userId =JSON.parse(localStorage.getItem('userInfo')).userId;
      let arr=localStorage.getItem('reviewerds')||''
      if(this.isAdmin || this.isReviewerLeader||arr.includes(userId.toString())) return true;
      if(this.form.taskId && this.form.demand_reviewer && !this.isTaskCopy){
        return this.form.demand_reviewer.nameEn === this.username;
      }
      return false;
    },
    isDevloper(){
      if(this.isAdmin || this.isDevLeader) return true;
      if(this.form.devloper){
        return this.form.devloper.nameEn === this.username;
      }
      return false;
    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isDevLeader(){
      if(this.userId && this.form.devloper){
        const devId = this.form.devloper.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[devId]){
          return this.allUserList.LEADERUSER[devId] === this.userId;
        }
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.demand_reviewer){
        const reviewerId = this.form.demand_reviewer.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    isHistoryReviewed() {
      return this.form.reviewed_status === 'history_reviewed'
    },
    newTitle() {
      if (this.isUpdate && !this.isTaskCopy) {
        return '[' + this.form.taskId + ']任务-' + this.form.name;
      } else {
        return '任务'
      }
    },
    nonStandard() { // 非标系统标识
      return this.form.module.startsWith('非标-')
    },
    isUploadFile(){
      return !(this.form.taskStatusCode === 2 && this.isDevloper);
    },
  },
  methods: {
    handleInput(event) {
      // 使用正则表达式限制输入内容
      const regex = /^(?:[0-9]|[1-2][0-9]|30)(?:\.[0-9])?$/;
      const inputValue = event.target.value;
      const match = regex.test(inputValue);
      if (match) {
        if(inputValue>30){
          this.form.revisionHour=0.0
          this.$notify({
          message:  "请输入0到30的能带一位小数!",
          type: "warning",
        });
        }
      } else {
        this.form.revisionHour=0.0
        this.$notify({
          message:  "请输入0到30的能带一位小数!",
          type: "warning",
        });
      }
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    selectBranch(val){
      const { taskId = "" } = this.form || {};
      if(val){
        postDevOpsSpaceUpdateBranchApi({taskId: taskId,branch: val});
      }

    },
    selectCodeReviewer(val){
      const { taskId = "" } = this.form || {};
      if(val){
        let codeReviewer = val.toString();
        postDevOpsSpaceUpdateBranchApi({taskId: taskId,codeReviewer: codeReviewer});
      }
    },
    onArrange(){
      this.dialogVisibleArrange = true;
      //开发中
     // this.showDialogVisible('developing',this.form);
      //测试环境测试中
      //this.hideDialogVisible('testEnvTesting');
    },
    async getBranchNew() {
      const {module = "", domain = ''} = this.form || {};
      try {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const ret = await getDevOpsSpaceGitListApi({
          module_name: module || "BACKEND",
          domain
        });
        let branchs = {}
        ret.data.branchs.map((item) => {
          branchs[item] = item;
        });
        this['BRANCHS'] = branchs;
        loading.close();
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
        loading.close();
      }finally {
        loading.close();
      }
    },
    async UpdateGitApi() {
      const {module = "", domain = ''} = this.form || {};
      try {
        const ret = await postDevOpsSpaceUpdateGitApi({
          module_name: module || "BACKEND",
          domain
        });
      } catch (error) {
        this.$notify({
          message: error || "更新分支失败",
          type: "error",
        });
      }
    },
    //获取分支
    async getBranchs(){
      const { module = "", domain = '' } = this.form || {};
      try {
        const ret = await postODUDADcreateApi({
          module_name: module || "BACKEND",
          domain
        });
        let branchs = {}
        ret.branchs.map((item) => { branchs[item] = item; });
        this['BRANCHS'] = branchs;
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    //提交测试
    async submitTest() {
      let flag = true;
      if (this.fileList.length > 0) {
        flag = false;
        const {id} = this.formInfo;
        let pid = id
        if (!this.isCreate) {
          pid = this.form.pid;
        }
        const res = await postDevopsSpaceTaskUpdateApi({
          ...this.form,
          demandId: Number(pid),
          developerId: Number(this.form.developerId),
          id: this.form.taskId,
          status: this.form.taskStatusCode,
          adjunct: JSON.stringify(this.fileList),
        })
        if(res.status === 'success'){
          flag = true;
        }else{
          this.$notify({
            message: res.message ||"失败",
            type: "error",
          })
          return false;
        }
      }
      if(flag){
        let currentTime = Date.parse(this.getNowDate());
        let planFinishDate = Date.parse(this.form.planFinishDate);
        if (currentTime > planFinishDate) {
          this.dialogVisibleDelay = true;
        } else {
          this.developSubmit(2);
        }
      }


    },
    //提交延期原因
    onSubmitDelay(){
      this.$refs["pSubmitForm"].validate(async (valid) => {
        if (valid) {
          this.$set(this.loading, 'submitDelay', true);
          //this.form.taskId
          postDevOpsSpaceSUbmitDelayReasonApi({taskId: Number(this.form.taskId),reasonCode: Number(this.pSubmitForm.reasonCode),reasonDetail: this.pSubmitForm.reasonDetail,type: 1,is_delay:1}).then((ret)=>{
           if(ret.status === 'success'){
             this.developSubmit(2);
           }else{
             this.$notify({
               message: ret.message ||"提交失败",
               type: "error",
             })
           }
            this.loading.submitDelay = false;
          });
        }
      })
    },
     async DelayReasonList() {
       await getDevOpsSpaceDelayReasonListApi({type: 1}).then((ret) => {
         let arr = {};
         ret.data.forEach((item) => {
           arr[item.reasonCode] = item.reasonDesc;
         })
         this.typeList = arr;
       });
     },
    async developSubmit(type){
      /*if(!this.form.module.startsWith('非标-')){
      }
      console.log(this.form.module.startsWith('非标-'));
      return false;*/
      this.$refs["pDevOpsForm"].validate(async (valid) => {
        if (valid) {
          const { taskId = "" } = this.form || {};
          const { branch = '' , codeReviewerId = ''} = this.pDevOpsForm || {};
          try {
            this.$set(this.loading, 'submitDev', true)
            const ret = await postDevOpsSpaceSubmitTaskApi({revisionHour:parseFloat(Number(this.form.revisionHour).toFixed(1)),type:type,id:taskId,branch: branch,codeReviewerId:codeReviewerId.toString()})

            if (!ret.message.status && ret.status === 'success') {
              this.$notify({
                message: "提交成功",
                type: "success",
              })
              this.hideDialogVisible()
              this.$set(this.loading, 'submitDev', false)
            } else {
              this.$notify({
                message: ret.message.data ||  ret.message,
                type: "error",
              })
              this.$set(this.loading, 'submitDev', false)
            }
          } catch (error) {
            this.$notify({
              message: error || "提交失败",
              type: "error",
            })
            this.$set(this.loading, 'submitDev', false)
          }finally {
            this.$set(this.loading, 'submitDev', false)
          }
        }

      })
    },
    //预估工时只能正整数
    handleEdit(e) {
      let value = e.replace(/^(0+)|[^\d]+/g,''); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
      if(value > 30){
        value = 30;
      }
      this.form.estimateWorkHour = Number(value)
    },
    // 初始化页面
    async init() {
      await this.queryDevOpsSpaceTaskDetail();
    },
    //获取代码审核人
    async getReviewUserList() {
      let reviewList = {};
      if (this.form.devloper && this.form.devloper.id) {
        await getDevOpsSpaceReviewUserListApi({user_id: this.form.devloper.id}).then((ret) => {
          ret.data.forEach((item, index) => {
            reviewList[item.id] = item.name;
          });
        });
      }
      this.reviewList = reviewList;
    },
    // 获取任务详情
    async queryDevOpsSpaceTaskDetail() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTaskDetailApi({
          taskId: this.form.taskId || "",
          pid: this.form.pid || '',
          space: 'producerSpace',
        });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          developerId: info.devloper.id ? info.devloper.id.toString() : '',
          codeReviewerId: info.codeReviewerId ? info.codeReviewerId.split(",") : [],
          taskId: info.id,
          pid: info.demandId,
        };
       if(info.adjunct){
         this.fileList = JSON.parse(info.adjunct);
       }
        this.pDevOpsForm.branch = this.form.branch;
        this.pDevOpsForm.codeReviewerId = this.form.codeReviewerId;
        this.formArrangeInfo = this.form;
        if(this.nonStandard){
          this.pDevOpsRules.branch = false;
        }
       // await this.getBranchs();
        if(!this.nonStandard) await  this.UpdateGitApi();
        this.reviewList  = this.allUserList.ALLUSERTYPE1;
        //if(info.devloper.id) await this.getReviewUserList(info.devloper.id);
        await this.DelayReasonList();
      } catch (error) {
        this.$notify({
          message: error || "获取任务详情失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:3,busiId: this.form.taskId}).then((res)=>{
         this.historylist = res.data;
      });
    },
    // 任务创建及更新
    async onSubmit() {
      if(this.form.taskStatusCode === 3 && !this.nonStandard && !this.pDevOpsForm.branch && this.step === 2){
        this.checkBranch = true;
        this.$notify({
          message: "请选择分支",
          type: "error",
        })
        return false;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const { id } = this.formInfo;
          let pid = id
          if(!this.isCreate){
           pid = this.form.pid;
          }

          try {
            this.$set(this.loading, 'submit', true)
            const ret = !this.isCreate ? await postDevopsSpaceTaskUpdateApi({...this.form,demandId:Number(pid),developerId:Number(this.form.developerId),id:this.form.taskId,status: this.form.taskStatusCode}) : await postDevOpsSpaceCreateTaskApi({...this.form,demandId:Number(pid),developerId:Number(this.form.developerId)});
            this.$notify({
              message: ret.message || "数据异常",
              type: ret.status === 'success' ? 'success' : "error",
            })
            //ret.status === 'success' && this.hideDialogVisible();
            ret.status === 'success' && this.handleClose();
          } catch (error) {
            this.$notify({
              message: error || "数据异常",
              type: "error",
            })
          } finally {
            this.loading.submit = false;
          }
        }
      })
    },
    handlePreview(file) {
      window.open(file?.response?.url || '')
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    beforeUpload(file){
      if (file.size / 1024 / 1024   > 5) {
        this.$notify({
          message:  "上传文件大小不能超过5M!",
          type: "error",
        });
        return false;
      }
    },
    // 格式化 props
    formatFormInfo(val) {
      if (val) {
        return val.split(',')
      }
      return []
    },
    handleArrangeClose(){
      this.dialogVisibleArrange = false;
    },
    // 关闭弹窗
    handleClose() {
      if(this.back){
        let data = this.formInfo;
        if(this.form.pid){
          data.id = this.form.pid;
        }
        console.log(22222);
        console.log(data)
        console.log(33333);
        this.hideDialogVisible('demand',data)
      }else{
        this.hideDialogVisible()
      }

    },
    // 从编辑到提交 1 -> 2
    changeStep() {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.$set(this, 'step', 2)
      })
    },
  }
};
</script>
<style lang="scss">
.task_model_dialog {

  .el-form-item__label {
    font-weight: bold;
  }

  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding-bottom: 0;
  }

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
  // #endregion select
}
</style>
